import { RecentTransactionsTable } from './../views/recent-transactions-table';
import { TransactionDTO } from './../dtos/transaction-DTO';
import { DATE_MDY } from './../../utils/date/date-parser';

export const RECENT_TRANSACTIONS_TABLE = (
	transactionsList: Array<TransactionDTO>
): Array<RecentTransactionsTable> => {
	let recentTransactions: Array<RecentTransactionsTable> = [];
	if (transactionsList.length > 0) {
		transactionsList.map((transaction: TransactionDTO) => {
			let recentTransaction = {} as RecentTransactionsTable;
			recentTransaction.origin = `${transaction.originCity},${transaction.originState}`;
			recentTransaction.destination = `${transaction.destinationCity},${transaction.destinationState}`;
			recentTransaction.trailerType = `${
				transaction.equipment.charAt(0).toUpperCase() + transaction.equipment.slice(1)
			}`;
			recentTransaction.allInCost = transaction.allInCost / 100;
			recentTransaction.originDeadhead = Math.round(transaction.originDeadhead);
			recentTransaction.destinationDeadhead = Math.round(transaction.destinationDeadhead);
			recentTransaction.pickupDate = DATE_MDY(transaction.pickupDate);
			let pricePerMile = transaction.allInCost / 100 / transaction.miles;
			recentTransaction.pricePerMile = Math.round(pricePerMile * 100) / 100;
			recentTransaction.age = formatAge(transaction.age);
			recentTransaction.miles = transaction.miles;
			recentTransaction.LoH = transaction.miles;
			recentTransaction.forThisAccount = transaction.forThisAccount;
			recentTransaction.deadheadDiff = Math.round(
				transaction.originDeadhead + transaction.destinationDeadhead
			);

			recentTransactions.push(recentTransaction);
		});
	}
	return recentTransactions;
};

const formatAge = (age: number): string => {
	let hours = '00',
		minutes = '00';
	if (age > 59) {
		hours = Math.floor(age / 60).toString();
	}
	if (age % 60 > 0) {
		minutes = (age % 60).toString();
	}
	return `${hours}:${minutes}`;
};
